import repository from "@/repository/admin/index";

export default {
    async getInfoOfPatient({commit}, patient_id) {
        const response = await repository.getInfoOfPatient({patient_id});
        commit("SET_PATIENT_INFO", response.data);
    }
}
